import { 
    Connector,
    OAuth2Service,
    toHttpRequest,
    HttpRequestError,
  } from "@/common";
import { Prompt, PromptParameter, TemplateParameters } from "..";

export interface IRephraseActions {

  /**
   * Action definition triggered to retrieve prompts list from tenant.
   * @param storeFunctions Commit and Dispatch functions to apply changes into the store.
   */
  fetchPromptsFromTenant(storeFunctions: any): any

  /**
   * Action definition triggered to retrieve prompt parameters list from tenant.
   * @param storeFunctions Commit and Dispatch functions to apply changes into the store.
   */
  fetchPromptParametersFromTenant(storeFunctions: any): any

  /**
   * Action definition triggered to retrieve parameters list from template.
   * @param storeFunctions Commit and Dispatch functions to apply changes into the store.
   */
  fetchTemplateParameters(storeFunctions: any): any

  /**
   * Action definition triggered to retrieve prompt parameters list from tenant.
   * @param storeFunctions Commit and Dispatch functions to apply changes into the store.
   */
  createPrompt(storeFunctions: any, prompt: Prompt): any

  /**
   * Action definition triggered to retrieve prompt parameters list from tenant.
   * @param storeFunctions Commit and Dispatch functions to apply changes into the store.
   */
  updatePrompt(storeFunctions: any, prompt: Prompt): any

  /**
   * Action definition triggered to retrieve prompt parameters list from tenant.
   * @param storeFunctions Commit and Dispatch functions to apply changes into the store.
   */
  deletePrompt(storeFunctions: any, id: string): any
  
  /**
   * Action definition triggered to retrieve langs list from tenant.
   * @param storeFunctions Commit and Dispatch functions to apply changes into the store.
   */
  fetchAuthorizedLangsFromTenant(storeFunctions: any): any

  /**
   * Action definition triggered to rephrase text
   * @param storeFunctions Commit and Dispatch functions to apply changes into the store.
   * @param payload The text to rephrase, promptId and tryAgain
   */
  rephrase(storeFunctions: any, payload:any): any

  /**
   * Action definition triggered to set prompt parameters.
   * @param storeFunctions Commit and Dispatch functions to apply changes into the store.
   */
  updatePromptParameters(storeFunctions: any, promptParams: PromptParameter): any

  /**
   * Action definition triggered to set current prompt.
   * @param storeFunctions Commit and Dispatch functions to apply changes into the store.
   */
  setCurrentPromptId(storeFunctions: any, prompt: string): any
}

export const RephraseActions: IRephraseActions = {

  async fetchPromptsFromTenant({rootState ,dispatch, commit}) {
    const token: string | undefined = rootState.usrSess.data ? OAuth2Service.getAccessToken(rootState.usrSess.data) : undefined
    const refreshtoken: string | undefined = rootState.usrSess.data ? OAuth2Service.getRefreshToken(rootState.usrSess.data) : undefined

    if (token) {
      const [err, response]: [HttpRequestError | undefined, any] = 
        await toHttpRequest(Connector.getFilterServerConnector().get(`/v1/prompt/all`, token, refreshtoken))
      if (err) {
        dispatch('errorHandling', err)
      } else if (response) {
        commit('SET_PROMPTS', response.data)
      }
    }
  },

  async fetchPromptParametersFromTenant({rootState ,dispatch, commit}) {
    const token: string | undefined = rootState.usrSess.data ? OAuth2Service.getAccessToken(rootState.usrSess.data) : undefined
    const refreshtoken: string | undefined = rootState.usrSess.data ? OAuth2Service.getRefreshToken(rootState.usrSess.data) : undefined

    if (token) {
      const [err, response]: [HttpRequestError | undefined, any] = 
        await toHttpRequest(Connector.getFilterServerConnector().get(`/v1/prompt/tenant/parameters`, token, refreshtoken))
      if (err) {
        dispatch('errorHandling', err)
      } else if (response) {
        commit('SET_PROMPT_PARAMETERS', response.data)
      }
    }
  },

  async fetchTemplateParameters({rootState ,dispatch, commit}) {
    const token: string | undefined = rootState.usrSess.data ? OAuth2Service.getAccessToken(rootState.usrSess.data) : undefined
    const refreshtoken: string | undefined = rootState.usrSess.data ? OAuth2Service.getRefreshToken(rootState.usrSess.data) : undefined

    if (token) {
      const [err, response]: [HttpRequestError | undefined, any] = 
        await toHttpRequest(Connector.getFilterServerConnector().get(`/v1/prompt/templates/parameters`, token, refreshtoken))
      if (err) {
        dispatch('errorHandling', err)
      } else if (response) {
        const templateParameters = response.data.map((template: any) => new TemplateParameters(template.template_id, template.value))
        commit('SET_TEMPLATE_PARAMETERS', templateParameters)
      }
    }
  },

  async createPrompt({rootState ,dispatch}, prompt) {
    const token: string | undefined = rootState.usrSess.data ? OAuth2Service.getAccessToken(rootState.usrSess.data) : undefined
    const refreshtoken: string | undefined = rootState.usrSess.data ? OAuth2Service.getRefreshToken(rootState.usrSess.data) : undefined
    
    console.log(prompt)
    console.log(rootState.rephrase.promptParameters)
    if (token) {
      const [err, response]: [HttpRequestError | undefined, any] = 
        await toHttpRequest(Connector.getFilterServerConnector().post(`/v1/prompt`, token, refreshtoken, { promptParameters: rootState.rephrase.promptParameters, prompt }))
      if (err) {
        dispatch('errorHandling', err)
        return true;
      } else {
        return false;
      }
    }
  },

  async updatePrompt({rootState ,dispatch}, prompt) {
    const token: string | undefined = rootState.usrSess.data ? OAuth2Service.getAccessToken(rootState.usrSess.data) : undefined
    const refreshtoken: string | undefined = rootState.usrSess.data ? OAuth2Service.getRefreshToken(rootState.usrSess.data) : undefined
    console.log(prompt)
    console.log(rootState.rephrase.promptParameters)
    if (token) {
      const [err, response]: [HttpRequestError | undefined, any] = 
        await toHttpRequest(Connector.getFilterServerConnector().put(`/v1/prompt`, token, refreshtoken, { promptParameters: rootState.rephrase.promptParameters, prompt }))
      if (err) {
        dispatch('errorHandling', err)
        return true;
      } else {
        return false;
      }
    }
  },

  async deletePrompt({rootState ,dispatch}, id: string) {
    const token: string | undefined = rootState.usrSess.data ? OAuth2Service.getAccessToken(rootState.usrSess.data) : undefined
    const refreshtoken: string | undefined = rootState.usrSess.data ? OAuth2Service.getRefreshToken(rootState.usrSess.data) : undefined

    if (token) {
      const [err, response]: [HttpRequestError | undefined, any] = 
        await toHttpRequest(Connector.getFilterServerConnector().delete(`/v1/prompt/${id}`, token, refreshtoken))
      if (err) {
        dispatch('errorHandling', err)
        return true;
      } else {
        return false;
      }
    }
  },

  async fetchAuthorizedLangsFromTenant({rootState ,dispatch, commit}) {
    const token: string | undefined = rootState.usrSess.data ? OAuth2Service.getAccessToken(rootState.usrSess.data) : undefined
    const refreshtoken: string | undefined = rootState.usrSess.data ? OAuth2Service.getRefreshToken(rootState.usrSess.data) : undefined

    if (token) {
      const [err, response]: [HttpRequestError | undefined, any] = 
        await toHttpRequest(Connector.getFilterServerConnector().get(`/v1/analytics/authorized-langs`, token, refreshtoken))
      if (err) {
        dispatch('errorHandling', err)
      } else if (response) {
        commit('SET_LANGS', response.data)
      }
    }
  },


  async rephrase({rootState ,dispatch}, {text, lang, promptId, tryAgain}) {
    const token: string | undefined = rootState.usrSess.data ? OAuth2Service.getAccessToken(rootState.usrSess.data) : undefined
    const refreshtoken: string | undefined = rootState.usrSess.data ? OAuth2Service.getRefreshToken(rootState.usrSess.data) : undefined

    if (token) {
      const [err, response]: [HttpRequestError | undefined, any] = 
        await toHttpRequest(Connector.getFilterServerConnector().post(`/v1/llm/rephrase`, token, refreshtoken, 
          { text, lang, promptId, tryAgain }))
      if (err) {
        return err;
      } else if (response) {
        return Object.values(response).join('');
      }
    }
  },

  updatePromptParameters({commit}, promptParameters) {
    commit('UPDATE_PROMPT_PARAMETERS', promptParameters)
  },

  setCurrentPromptId({commit}, prompt) {
    commit('SET_CURRENT_PROMPT_ID', prompt)
  }
}
